import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const certificates = [
  {
    src: "CMMI-Level-5-Software-Certificate.jpg",
    title: "CMMI Level-5 Software Certificate",
  },
  {
    src: "DIPP-Strat-up.jpg",
    title: "DIPP Start-up Certificate",
  },
  {
    src: "Installation-License.jpg",
    title: "Baggage Manufacturing License",
  },
  {
    src: "Factory-License-RePrint-Certificate-FIRSTFLOOR.jpg",
    title: "Factory License",
  },
  {
    src: "Factory-License-RePrint-Certificate-MANUFACTURING.jpg",
    title: "Manufacturing Factory License",
  },
  {
    src: "GST.jpg",
    title: "GST",
  },
  {
    src: "ISO-9001.jpg",
    title: "ISO-9001",
  },
  {
    src: "ISO-14001.jpg",
    title: "ISO-14001",
  },
  {
    src: "ISO-20000-1.jpg",
    title: "ISO-20000-1",
  },
  {
    src: "ISO-27001.jpg",
    title: "ISO-27001",
  },
  {
    src: "ISO-45001.jpg",
    title: "ISO-45001",
  },
  {
    src: "MSME.jpg",
    title: "MSME Certificate",
  },
  {
    src: "MSME-ZED.jpg",
    title: "MSME ZED Certificate",
  },
];

const Certification = () => {
  const [fullscreenImage, setFullscreenImage] = useState(null);

  const handleImageClick = (src) => {
    const imagePath = require(`../assets/certificates/${src}`);
    setFullscreenImage(imagePath);
  };

  const closeFullscreen = () => {
    setFullscreenImage(null);
  };

  return (
    <>
      <div
        className="container text-center my-5"
        style={{
          userSelect: "none",
          pointerEvents: "auto",
          position: "relative",
        }}
      >
        <h2>Certificates</h2>
        <div className="row">
          {certificates.map((certificate, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
              <div className="card h-100">
                <img
                  src={require(`../assets/certificates/${certificate.src}`)}
                  className="card-img-top img-fluid"
                  alt={`Certificate ${index + 1}`}
                  onClick={() => handleImageClick(certificate.src)}
                  style={{
                    cursor: "pointer",
                    border: "2px solid black",
                    userSelect: "none",
                    pointerEvents: "auto",
                  }}
                />
                <div className="card-body">
                  <p className="card-title fw-bold" style={{ color: "black" }}>
                    {certificate.title}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {fullscreenImage && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-75"
          onClick={closeFullscreen}
          style={{
            zIndex: 1050,
            cursor: "pointer",
          }}
        >
          <img
            src={fullscreenImage}
            alt="Fullscreen"
            className="img-fluid"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
            }}
          />
        </div>
      )}
    </>
  );
};

export default Certification;
